// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__etj8c","addWidgetButton":"Header_addWidgetButton__1aRAU","dashboardTabs":"Header_dashboardTabs__1NUjh","active":"Header_active__3CU2J"};